import { render, staticRenderFns } from "./upload-head.vue?vue&type=template&id=021a0e06&scoped=true&"
import script from "./upload-head.vue?vue&type=script&lang=ts&"
export * from "./upload-head.vue?vue&type=script&lang=ts&"
import style0 from "./upload-head.vue?vue&type=style&index=0&id=021a0e06&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021a0e06",
  null
  
)

export default component.exports